import Box from "@mui/material/Box";
import { Button } from "components";

export const ButtonApply = () => {
  return (
    <Box
      sx={{
        width: "100px",
        marginLeft: "12px",
        display: "flex",
        justifyContent: "end",
      }}
    >
      <Button
        type="submit"
        sx={{
          width: "68px",
          alignSelf: "end",
          padding: "8px 14px",
        }}
        variant="contained"
      >
        Apply
      </Button>
    </Box>
  );
};
